module.exports = __webpack_public_path__ + "./images/71c43858f62706f80ee9a336035a4e93.png";